import { LegalLayout } from "./components/legalLayout";
import { CONTACT } from "./content/contact";

/** /contato — canais de atendimento, no mesmo molde dos documentos legais. */
export const Contato = () => <LegalLayout document={CONTACT} />;
